import { Col, Row, Tag } from 'antd';
import { PlusIcon, XIcon } from 'assets/svg';
import { Button } from 'components';
import { Dispatch } from 'react';
import { formatCurrency, toastError } from 'utils/constants/functions';
import { useAmlCheck } from 'hooks/useAmlCheck';

interface Iprops {
  data: any;
  setData: Dispatch<any>;
  handleAddCusomer: (data: any) => void;
  type?: string;
  cusType?: string;
  setOpenMap: Dispatch<boolean>;
  setLocation: Dispatch<any>;
}

const getAddress = ({
  address,
  cityName,
  districtName,
  wardName,
}: {
  address: string | null;
  wardName: string | null;
  districtName: string | null;
  cityName: string | null;
}) => {
  const res = [address, wardName, districtName, cityName]
    .filter((item) => item)
    .join(', ');

  if (!res) return 'Chưa cập nhật';

  return `Địa chỉ: ${res}`;
};

function CustomerCard(props: Iprops) {
  const {
    data,
    setData,
    setOpenMap,
    setLocation,
    handleAddCusomer,
    type,
    cusType,
  } = props;
  const { checkAndProceed, amlModalContext } = useAmlCheck();

  const AddCustomer = (newCustomer: any) => {
    checkAndProceed(
      {
        ...newCustomer,
        id: newCustomer.id || newCustomer.customerId,
      },
      () => {
        if (cusType)
          setData?.((prev: any) => ({
            ...prev,
            [cusType]: prev[cusType].filter((item: any) => {
              const isExist = [newCustomer.id, newCustomer.customerId].includes(
                item.id,
              );

              return !isExist;
            }),
          }));
        handleAddCusomer((prev: any[]) => {
          if (
            prev.findIndex((item: any) =>
              [newCustomer.id, newCustomer.customerId].includes(item.id),
            ) === -1
          )
            return [
              ...prev,
              {
                ...newCustomer,
                id: newCustomer.id || newCustomer.customerId,
                type: cusType,
              },
            ];
          return prev;
        });
      },
    );
  };

  const DeleteCustomer = (newCustomer: any) => {
    handleAddCusomer((prev: any[]) =>
      prev.filter((item: any) => {
        const isExist = [newCustomer.id, newCustomer.customerId].includes(
          item.id,
        );

        return !isExist;
      }),
    );

    // console.log(setData);

    if (newCustomer.type)
      setData?.((prev: any) => ({
        ...prev,
        [newCustomer.type]: [...prev[newCustomer.type], newCustomer],
      }));
  };

  return (
    <>
      {(data || []).map((item: any, index: number) => {
        return (
          <Row
            key={index}
            gutter={[8, 8]}
            align={'top'}
            justify={'space-around'}
            style={{ width: '100%', marginBottom: '10px' }}
            className={`${index != data?.length && 'border-b-2 pb-2'} h-max`}
          >
            <Col span={2} className="flex justify-center items-center h-full">
              {type == 'tab1' ? (
                <Button
                  customClass="bg-white w-10 h-10"
                  title={<XIcon />}
                  handleOnclick={() => DeleteCustomer(item)}
                />
              ) : (
                <Button
                  customClass="bg-white w-10 h-10"
                  title={<PlusIcon />}
                  handleOnclick={() => AddCustomer(item)}
                />
              )}
            </Col>
            <Col span={22}>
              <Row style={{ width: '100%' }} gutter={[8, 8]} align={'middle'}>
                <Col
                  style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#003056',
                  }}
                >
                  {item?.storeName || '-'}
                </Col>
                <Col>
                  {item?.rankName ? (
                    <Tag
                      color="blue"
                      style={{ fontWeight: 'bold', fontSize: '14px' }}
                    >
                      <span style={{ color: '#003056' }}>{item?.rankName}</span>
                    </Tag>
                  ) : null}
                </Col>
              </Row>

              <div>
                <span className="text-base text-[#003056]">
                  {getAddress({
                    address: item?.address,
                    cityName: item?.cityName,
                    districtName: item?.districtName,
                    wardName: item?.wardName,
                  })}
                </span>
                <button
                  className="ml-2"
                  // disabled
                  onClick={() => {
                    if (!item?.latitude && !item?.longitude) {
                      toastError('Khách hàng chưa có vị trí');
                      return;
                    }
                    setOpenMap(true);
                    setLocation(item);
                  }}
                >
                  <span
                    style={{
                      color: '#003056',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                    }}
                  >
                    Xem bản đồ
                  </span>
                </button>
              </div>

              <Row style={{ width: '100%' }} gutter={[8, 8]} align={'middle'}>
                <Col
                  style={{
                    fontSize: '16px',
                    color: '#003056',
                  }}
                >
                  Doanh thu trung bình:
                </Col>
                <Col style={{ color: '#003056', fontWeight: 'bold' }}>
                  {item?.income
                    ? formatCurrency({
                        value: item?.income,
                      })
                    : '-'}
                  &nbsp; vnd
                </Col>
              </Row>
            </Col>
          </Row>
        );
      })}
      {amlModalContext}
    </>
  );
}

export default CustomerCard;
